import script from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AppNavbar.vue?vue&type=style&index=0&id=38a0ac9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a0ac9f"]])

export default __exports__